export const LOGIN_USER = 'LOGIN_USER_FOR_UPLOADER';
export const LOGOUT_USER = 'LOGOUT_USER_FOR_UPLOADER';

export const UPDATE_CONFIGURATOR_FIELD = 'UPDATE_CONFIGURATOR_FIELD';
export const CLEAR_PROJECT_DATA = 'CLEAR_PROJECT_DATA';
